import React from 'react';
import v4 from 'uuid';
import * as Yup from 'yup';
import { parseDateFromFormats } from '../../../utilities/parseDate';



export const segmap = () => ({
    id: v4(),
    parent_group: null,
    mul_dealer_cd: null,
    outlet_cd: null,
    loc_cd: null,
    dealer_for_cd: null,
    cid: null,
    segid: null,
    seg_ledger: null,
    seg_ledger_cd: null,
    cost_center: null,
    cost_center_tv: null,
    cost_cetagory: null,
    billing_code: '',
    godown: null,
    companyGstin: null,
    cust_group_vh: null,
    cust_group_ws: null,
    cust_group_tv: null,
    loc_custGrp_applicable: "n",
    ew_segid: null,
    ci_segid: null,
    ci_godown: null,
    pp_segid: null,
    pp_godown: null,
    wi_segid: null,
    wi_godown: null,
    wi_cost_center: null,
    wi_bndp_cost_center: null,
    stpi_segid: null,
    stpi_segLedger: null,
    stpi_seg_ledger_cd: null,
    stpi_godown: null,
    loc_nature: null,
    r_segid: null,
    wi_bndp_segid: null,
    wi_bndp_godown: null,

    wi_sl_pur_ledger: null,
    wi_sl_pur_ledger_cd: null,
    ci_sl_pur_ledger: null,
    ci_sl_pur_ledger_cd: null,
    pp_sl_pur_ledger: null,
    pp_sl_pur_ledger_cd: null,
    ew_sl_pur_ledger: null,
    ew_sl_pur_ledger_cd: null,
    ewc_sl_pur_ledger: null,
    ewc_sl_pur_ledger_cd: null,
    ccp_sl_pur_ledger: null,
    ccp_sl_pur_ledger_cd: null,
    ccpc_sl_pur_ledger: null,
    ccpc_sl_pur_ledger_cd: null,

    visible: null,
    cash_bank_map: null,
    status: 1,
    uid_create: "",
    uid_update: "",
    dt_create: "",
    dt_update: "",
    seperateWsToggle: "no",
    bussinessCustGroupToggle: "no",
    locToggle: "no",
    cashBankMapToggle: "no",
    transTypeToggle: "no",
    vs_post_from_ci : 0,


})


export const depositBankObj = () => ({
    payment_mode: "",
    deposit_bank_arr: [
        {
            deposit_bank: "",
            bank_ledger: "",
            ledger_code: ""
        }
    ]
})

export const depositBankSubArray = () => ({
    deposit_bank: "",
    bank_ledger: "",
    ledger_code: ""
})

Yup.addMethod(Yup.date, 'format', parseDateFromFormats);
export const segmapSchema = Yup.object().shape({

    id: Yup.string()
        .required('This is a Required Field'),
    parent_group: Yup.string()
        .required('Parent Group Required').nullable(),

    mul_dealer_cd: Yup.string()
        .required('Mul Dealer Code Required').nullable(),

    outlet_cd: Yup.string()
        .required('Outlet Code Required').nullable(),
    loc_cd: Yup.string()
        .required('Location Code Required').nullable(),
    dealer_for_cd: Yup.string()
        .required('Dealer For Cd Required').nullable(),
    cid: Yup
        .number() // Validates for numerical value
        .typeError('Company ID must be a number')
        .positive("Company ID must be a positive number") 
        .required('Company ID Required').nullable(),
    segid: Yup
        .number() // Validates for numerical value
        .typeError('Segment ID must be a number')
        .positive("Segment ID must be a positive number") 
        .required('Segment ID Required').nullable(),
    seg_ledger: Yup.string()
        .required('Segment Ledger Required').nullable(),
    seg_ledger_cd: Yup.string()
        .required('Segment Ledger Code Required').nullable(),
    godown: Yup.string()
        .required('Godown Required').nullable(),
    r_segid: Yup.number().typeError("RCP segid must be a Number").nullable(),
    wi_bndp_segid: Yup.number().typeError("BANDP segid must be a Number").nullable(),
    wi_bndp_godown: Yup.string().max(100, "BANDP Godown Max 100 character Allowed").nullable(),

    status: Yup.number().integer().nullable(),
    txnid: Yup.string().nullable(),
    dt_create: Yup.string().nullable(),
    dt_update: Yup.string().nullable(),
    user_create: Yup.string().nullable(),
    user_update: Yup.string().nullable()

});


// export const duplicateCheckSegmapCode = debounce(checkSegmapCode, 500);
// function checkSegmapCode (value)  {
// 	if (value.length > 0)
// 		return axios.post(URL+'/segmap/exists/'+ value, {type: 'checkCode'})
// 			.then(response => {
// 						if (response.data==='duplicate') {
// 							console.log("response",response.data)
// 							return "Duplicate"
// 						}
// 					})
// 			.catch(error => "")
//   }


// export const duplicateCheckSegmapName = debounce(checkSegmapName, 500);
// function checkSegmapName (value)  {
//     if (value.length > 2)
//         return axios.post(URL+'/segmap/exists/'+ value, {type: 'checkName'})
//             .then(response => {
//                         if (response.data==='duplicate') {
//                             console.log("response",response.data)
//                             return "Duplicate"
//                         }
//                     })
//             .catch(error => "")
// }

export const searchColumns = [
    {
        Header: <div style={{ textAlign: 'left' }} >PARENT GROUP</div>,
        accessor: 'parent_group',
        Cell: row => <div className='ellipsisDiv' style={{ width: '150px', paddingLeft: "8px" }} title={(row.value && row.value !== undefined && row.value !== null && row.value !== 'NULL' && row.value !== "0" && row.value !== 0) ? row.value : ""}>{(row.value && row.value !== undefined && row.value !== null && row.value !== 'NULL' && row.value !== "0" && row.value !== 0) ? row.value : ""}</div>,
        classNameGet: 'segmapfilter7',

    },
    {
        Header: <div style={{ textAlign: 'left' }} >MUL DEALER CD</div>,
        accessor: 'mul_dealer_cd',
        Cell: row => <div style={{ textAlign: "left", paddingLeft: "5px" }} title={(row.value && row.value !== undefined && row.value !== null && row.value !== 'NULL' && row.value !== "0" && row.value !== 0) ? row.value : ""}>{(row.value && row.value !== undefined && row.value !== null && row.value !== 'NULL' && row.value !== "0" && row.value !== 0) ? row.value : ""}</div>,
        classNameGet: 'segmapfilter1',

    },
    {
        Header: <div style={{ textAlign: 'left' }} >LOC CD</div>,
        accessor: 'loc_cd',
        Cell: row => <div style={{ textAlign: "left", paddingLeft: "5px" }}>{(row.value && row.value !== undefined && row.value !== null && row.value !== 'NULL' && row.value !== "0" && row.value !== 0) ? row.value : ""}</div>,
        classNameGet: 'segmapfilter2'
    },
    {
        Header: <div style={{ textAlign: 'left' }} >OUTLET CD</div>,
        accessor: 'outlet_cd',
        Cell: row => <div style={{ textAlign: "left", paddingLeft: "5px" }} title={(row.value && row.value !== undefined && row.value !== null && row.value !== 'NULL' && row.value !== "0" && row.value !== 0) ? row.value : ""}>{(row.value && row.value !== undefined && row.value !== null && row.value !== 'NULL' && row.value !== "0" && row.value !== 0) ? row.value : ""}</div>,
        classNameGet: 'segmapfilter3',

    },
    {
        Header: <div style={{ textAlign: 'left' }} >DEALER FOR CD</div>,
        accessor: 'dealer_for_cd',
        Cell: row => <div style={{ textAlign: "left", paddingLeft: "5px" }}>{(row.value && row.value !== undefined && row.value !== null && row.value !== 'NULL' && row.value !== "0" && row.value !== 0) ? row.value : ""}</div>,
        classNameGet: 'segmapfilter4'
    },
    {
        Header: <div style={{ textAlign: 'left' }} >SEGMENT LEDGER</div>,
        accessor: 'seg_ledger',
        Cell: row => <div className='ellipsisDiv' style={{ width: '90%', paddingLeft: "8px" }} title={(row.value && row.value !== undefined && row.value !== null && row.value !== 'NULL' && row.value !== "0" && row.value !== 0) ? row.value : ""}>{(row.value && row.value !== undefined && row.value !== null && row.value !== 'NULL' && row.value !== "0" && row.value !== 0) ? row.value : ""}</div>,
        classNameGet: 'segmapfilter5',

    },
    {
        Header: <div style={{ textAlign: 'left' }} >GODOWN</div>,
        accessor: 'godown',
        Cell: row => <div style={{ textAlign: "left", paddingLeft: "5px" }}>{(row.value && row.value !== undefined && row.value !== null && row.value !== 'NULL' && row.value !== "0" && row.value !== 0) ? row.value : ""}</div>,
        classNameGet: 'segmapfilter6'
    },

]